import { BASE_URL_V2 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'PROGRAMS_GET_ALL',
  GET_ALL_SUCCESS: 'PROGRAMS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'PROGRAMS_GET_ALL_FAILURE',
  PATCH: 'PROGRAMS_PATCH',
  PATCH_SUCCESS: 'PROGRAMS_PATCH_SUCCESS',
  PATCH_FAILURE: 'PROGRAMS_PATCH_FAILURE',
  INVALIDATE_ITEM: 'PROGRAMS_INVALIDATE',
};

export const patch = actions.patch(userId => `${BASE_URL_V2}/students/${userId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
